module.exports = __webpack_public_path__ + "assets-cabinet/img/button-toggle.2c47b683.svg";